"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getElasticsearchQueryForSearch(searchMatchConfig) {
    const query = { bool: { must: [{ match: searchMatchConfig }] } };
    return query;
}
exports.getElasticsearchQueryForSearch = getElasticsearchQueryForSearch;
//# sourceMappingURL=getElasticsearchQueryFromSearch.js.map